import { Injectable } from '@angular/core'
import { Subject } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service'
import { Location } from '@angular/common'
import { User } from './user.model';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    
    private userUpdate = new Subject<any>();
    userUpdate$ = this.userUpdate.asObservable();
    
    jwt = new JwtHelperService();
    token;
    scopedRegions;
    isAdmin = false;
    isSuperAdmin = false;
    isAuthorized = false;
    user: User;
    isEnrolled = false;

    regions = {
            'area-l': 1,
            'charlotte': 2,
            'south-east': 3,
            'eastern': 4,
            'greensboro': 5,
            'mountain': 6,
            'northwest': 7,
            'southern': 8,
            'wake': 9,
            'program-office': 10,
            'duke-program-office': 11
        }

    constructor(
        private cookieService: CookieService,
        private location: Location,
    ) {}

    authenticate() {
        this.isAdmin = this.authorize();
        this.isAuthorized = this.authorize();
        this.userUpdate.next();
    }

    authorize(){
        if ( !this.validate() ) return false
            
        const token = this.jwt.decodeToken(this.token);

        let courseAdminScopes = token.scope.split(' ').filter((value: string) => {
            return value.match(/^courses-admin[-a-zA-Z0-9]*$/);
        });
        
        this.isSuperAdmin = (courseAdminScopes.indexOf('courses-admin') > -1)
        
        this.scopedRegions = (this.isSuperAdmin) ?
                Object.values(this.regions)
            :
                courseAdminScopes.map((region) => {
                    return this.regions[region.replace('courses-admin-', '')];
                });

        if ( this.scopedRegions.length === 0) return false

        return true
    }

    deny(){
        console.log("please sign-in");
        this.cookieService.set("redirect", `${window.location.origin}${this.location.prepareExternalUrl(this.location.path())}`, 0, "/")
        window.location.href = `${window.location.origin}/sign-in`
        return
    }

    validate(){
        if (!this.cookieService.check('token')) return false;
        this.token = this.cookieService.get('token');
        if (this.jwt.isTokenExpired(this.token)) return false;
        return true;
   }
}